import React, { useState, useRef, useEffect, useCallback } from 'react'
import { theme } from 'theme'
import Text from 'particles/Text'
import { Paper, Popper } from '@mui/material'
import { useWindowSize } from 'hooks'
import SmallScreenPopper from 'components/Shared/SmallScreenPopper'
import styled from 'particles/themes/styled'
import Checkbox from 'particles/Checkbox'

const CheckBoxContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
`

interface CheckBoxCellProps {
    popupTitle?: string
    popupInfoContent?: string
    isPopupInfo?: boolean
    isShowBlank?: boolean
    onCheckColor?: string
    disabled?: boolean
    size?: number
    onCheck?: () => void
    isChecked?: boolean
    access?: boolean
    dataTestId?: string
}

export const CheckBoxCell = React.memo(function GridCellExpand(props: CheckBoxCellProps) {
    const {
        popupTitle = '',
        popupInfoContent,
        isShowBlank = false,
        isPopupInfo = false,
        disabled = false,
        isChecked = false,
        onCheck,
        access = true,
        dataTestId,
    } = props
    const [showPopper, setShowPopper] = useState(false)
    const targetElement = useRef(null)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const windowSize = useWindowSize()
    const handleTogglePopper = useCallback(() => {
        if (isPopupInfo) {
            setShowPopper(show => !show)
        }
    }, [isPopupInfo])
    const popupContent = popupInfoContent ? popupInfoContent : popupTitle
    useEffect(() => {
        if (targetElement.current) {
            setAnchorEl(targetElement.current)
        }
    }, [])
    if (isShowBlank) return <></>
    return (
        <CheckBoxContainer data-testid={dataTestId}>
            {access ? (
                <div onMouseEnter={handleTogglePopper} onMouseLeave={handleTogglePopper}>
                    <Checkbox
                        ref={targetElement}
                        isDisabled={disabled}
                        checkbox={isChecked ? 'selected' : 'notSelected'}
                        onChange={onCheck}
                        size="m"
                    />
                </div>
            ) : isChecked ? (
                <Checkbox isReadOnly checkbox="selected" size="m" />
            ) : (
                <></>
            )}

            {showPopper && (
                <>
                    {windowSize && windowSize > 768 ? (
                        <Popper open={anchorEl !== null} anchorEl={anchorEl} style={{ marginLeft: -17, zIndex: 1 }}>
                            <Paper
                                elevation={1}
                                style={{
                                    background: theme.newColors.neutral600,
                                    width: '224px',
                                    maxWidth: '224px',
                                    padding: 8,
                                    boxShadow:
                                        '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
                                }}
                            >
                                <Text color="primaryInverse" scale="caption400">
                                    {popupContent}
                                </Text>
                            </Paper>
                        </Popper>
                    ) : (
                        <Popper
                            open={anchorEl !== null}
                            style={{
                                position: 'fixed',
                                zIndex: 999,
                            }}
                        >
                            <SmallScreenPopper
                                title={popupTitle}
                                description={popupInfoContent}
                                setShow={() => {
                                    setShowPopper(false)
                                }}
                            />
                        </Popper>
                    )}
                </>
            )}
        </CheckBoxContainer>
    )
})
